import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../config';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class SkladisteHladService {

  constructor(private _http: HttpClient) { }

  ukupanPromet(a: any) {
    return this._http.post(AppConfig.ipAddress + 'ukupan_promet_hlad', a)
      .pipe(map((res: any) => res));
  }

  trenutanPromet(a: any) {
    return this._http.post(AppConfig.ipAddress + 'trenutan_promet_hlad', a)
      .pipe(map((res: any) => res));
  }

}
